import { render, staticRenderFns } from "./shippingOperations.vue?vue&type=template&id=c6748dd2&"
import script from "./shippingOperations.vue?vue&type=script&lang=js&"
export * from "./shippingOperations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports